import { render } from "./AddToCart.vue?vue&type=template&id=97a2eb5c&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"

import "./AddToCart.vue?vue&type=style&index=0&id=97a2eb5c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a2eb5c"]])

export default __exports__